import React, { useState } from 'react';
import { Card, Table, Tag, Button, Space, Empty } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import CampaignRequestorComplianceAudiencesDialog from './CampaignRequestorComplianceAudiencesDialog';

const classificationTagConfig = {
  COMPLIANCE_MEDICAL: { color: 'green', label: 'Medical' },
  COMPLIANCE_RECREATIONAL: { color: 'blue', label: 'Recreational' },
  COMPLIANCE_BOTH: { color: 'purple', label: 'Both' },
};

const CampaignRequestorComplianceAudiences = ({
  complianceAudiences = [],
  onAddAudiences,
  onRemoveAudience,
  advertiserId,
  readOnly = false,
}) => {
  const [dialogVisible, setDialogVisible] = useState(false);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: 200,
    },
    {
      title: 'Classification',
      dataIndex: 'type',
      key: 'type',
      width: 150,
      render: (type) => {
        const config = classificationTagConfig[type] || { color: 'default', label: type };
        return <Tag color={config.color}>{config.label}</Tag>;
      },
    },
    {
      title: 'Locations',
      dataIndex: 'geoTargets',
      key: 'geoTargets',
      render: (geoTargets) => {
        if (!geoTargets || geoTargets.length === 0) return '-';
        const locationNames = geoTargets
          .map((gt) => gt?.location?.name || gt?.name)
          .filter(Boolean);
        return locationNames.join(', ');
      },
    },
    // Only show Action column if not in read-only mode
    ...(!readOnly ? [{
      title: 'Action',
      key: 'action',
      width: 100,
      render: (_, record) => (
        <Button
          type="text"
          danger
          icon={<DeleteOutlined />}
          onClick={() => onRemoveAudience(record.id)}
        />
      ),
    }] : []),
  ];

  const handleAddSelections = (selectedAudiences) => {
    if (onAddAudiences) {
      onAddAudiences(selectedAudiences);
    }
  };

  return (
    <>
      <Card
        title="COMPLIANCE TARGETING"
        extra={
          !readOnly && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setDialogVisible(true)}
            >
              Add Compliance Audience
            </Button>
          )
        }
      >
        {complianceAudiences && complianceAudiences.length > 0 ? (
          <Table
            rowKey="id"
            columns={columns}
            dataSource={complianceAudiences}
            pagination={false}
            size="small"
          />
        ) : (
          <Empty description="No compliance audiences attached" />
        )}
      </Card>
      {!readOnly && dialogVisible && (
        <CampaignRequestorComplianceAudiencesDialog
          visible={dialogVisible}
          setVisible={setDialogVisible}
          orgId={advertiserId}
          onAddSelections={handleAddSelections}
          selectedAudiences={complianceAudiences}
        />
      )}
    </>
  );
};

export default CampaignRequestorComplianceAudiences;
